const mEditionProductAssetsIncludedMaps = {
  mEditionProductAssetsIncludedMaps: {
    actions: {
      add: 'Incluir',
      remove: 'Quitar'
    },

    alerts: {
      updateProductoProyectos: {
        success: 'Mapas inlcuidos actualizados exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      }
    },

    buttonSecondary: {
      addAllText: 'Incluir Todos',
      removeAllText: 'Quitar Todos'
    },

    quote: {
      firstText: 'Aún no tienes mapas publicados para incluir en la venta de tu producto.',
      secondText: 'Aún no tienes mapas incluidos en tu producto.',
      thirdText: 'Selecciona uno o varios mapas para vender, estos solo pueden ser incluidos mientras estén publicados.',
      fourthText: 'Si seleccionas más de un mapa puedes venderlos como un pack de formación.'
    },

    subTitles: {
      included: 'Incluidos',
      notIncluded: 'No Incluidos'
    }
  }
}

export default mEditionProductAssetsIncludedMaps
